import { Download } from '@webapp/common/assets/icons';

import css from './download-report-button.css';

export const DownloadReportButton: FC<{
    onClick: () => void;
    title?: string;
}> = ({ onClick, title = 'Скачать отчет' }) => (
    <div className={css.download} onClick={onClick}>
        <Download />
        <span>{title}</span>
    </div>
);
